/* unplugin-vue-components disabled */import { render } from "./letter.vue?vue&type=template&id=2199085e&scoped=true&ts=true"
import script from "./letter.vue?vue&type=script&lang=ts"
export * from "./letter.vue?vue&type=script&lang=ts"

import "./letter.vue?vue&type=style&index=0&id=2199085e&scoped=true&lang=scss"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2199085e"]])

export default __exports__